import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '@/components/Layout';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { Phone } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ActualizarContactoPage = ({ user, onLogout }) => {
  const [celular, setCelular] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/contacto/parent-number`, authHeaders());
        setCelular(res.data.celular || '');
      } catch (e) {
        toast.error('No se pudo cargar el número');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/contacto/parent-number`, { celular }, authHeaders());
      toast.success('Número de contacto actualizado');
    } catch (e) {
      toast.error('Error al guardar el número');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="max-w-lg mx-auto space-y-6" data-testid="actualizar-contacto-page">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-indigo-600 flex items-center justify-center">
            <Phone className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-800">Actualizar Número de Contacto</h1>
            <p className="text-sm text-slate-500">Este número lo verá la escuela para contactarte</p>
          </div>
        </div>

        <Card className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Número Celular</label>
            {loading ? (
              <p className="text-slate-400 text-sm mt-2">Cargando...</p>
            ) : (
              <Input
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                placeholder="Ej. 55 1234 5678"
                className="mt-1"
                data-testid="contacto-celular-input"
              />
            )}
            <p className="text-xs text-slate-400 mt-1">Puedes usar espacios, guiones o el prefijo + (ej. +52 55 1234 5678).</p>
          </div>
          <Button onClick={handleSave} disabled={saving || loading} className="w-full bg-indigo-600 hover:bg-indigo-700" data-testid="contacto-save-btn">
            {saving ? 'Guardando...' : 'Guardar número'}
          </Button>
        </Card>
      </div>
    </Layout>
  );
};

export default ActualizarContactoPage;
